import WebSocketClient  from './helpers/webSocketClient';
import env              from './env';

const wsc = new WebSocketClient(`${process.env.REACT_APP_MESSENGER_HOST}/sync`);

export default {
    wsc,
    webapp_url: env.WEBAPP_HOST,
    commcontroller_url: env.COMMCONTROLLER_HOST,
    security_url: env.SECURITY_HOST,
    messenger_url: env.MESSENGER_HOST,
    smartlist_url: env.SMARTLIST_HOST,
    smartlist_filter_url: env.SMARTLIST_FILTER_HOST,
};



// WEBPACK FOOTER //
// ./src/config.tsx